import React from "react";
import classnames from "classnames";
import { useWheelEventPreventDefault } from "./kits-dropdown";
import _forEach from "lodash/forEach";
import { connect } from "react-redux";
import * as actions from "../../actions/actions";

const KitErrors = ({ errors }) => {
    let content = [];
    if (errors) {
        _forEach(errors, (fieldName, msg) => {
            content.push(msg);
            content.push(<br key={fieldName} />);
        });
    }
    if (!content.length) {
        return null;
    }
    let classname = classnames("message", {
        error: content.length
    });
    return <span className={classname}>{content}</span>;
};

const UnwrappedKitForm = ({
    kit,
    kitsInputChange,
    kitCreators,
    onSubmit,
    fieldErrors
}) => {
    let [ref] = useWheelEventPreventDefault();
    let nameInputRef = React.useRef(null);
    React.useEffect(() => {
        if (nameInputRef && nameInputRef.current) {
            nameInputRef.current.focus();
        }
    }, [nameInputRef]);
    let onNameChange = React.useCallback(
        e => {
            kitsInputChange("name", e.target.value);
        },
        [kitsInputChange]
    );
    let onDescriptionChange = React.useCallback(
        e => {
            kitsInputChange("description", e.target.value);
        },
        [kitsInputChange]
    );
    let onIsPublicChange = React.useCallback(
        e => {
            kitsInputChange("is_public", e.target.checked);
        },
        [kitsInputChange]
    );
    let onOwnerIdChange = React.useCallback(
        e => {
            kitsInputChange("owner_id", e.target.value);
        },
        [kitsInputChange]
    );

    let handleSubmit = React.useCallback(
        e => {
            e && e.preventDefault();
            onSubmit();
        },
        [onSubmit]
    );

    let { name, description, is_public, owner_id } = kit;
    let ownerOptions, ownerSelect;
    if (kitCreators && kitCreators.length != 1) {
        ownerOptions = kitCreators.map(kitCreator => {
            return (
                <option key={kitCreator.value} value={kitCreator.value}>
                    {kitCreator.name}
                </option>
            );
        });
        ownerSelect = (
            <div className="fat-input">
                <label
                    id="new-kit-owner"
                    htmlFor="kit-owner"
                    className="ui_user icon-label"
                    title="Kit owner"
                />
                <div className="select-hold ui_down-triangle-after">
                    <select
                        data-test-id="kit-owner-input"
                        id="new-kit-owner"
                        name="new-kit-owner"
                        value={owner_id}
                        onChange={onOwnerIdChange}
                    >
                        {ownerOptions}
                    </select>
                </div>
            </div>
        );
    }

    return (
        <form className="visible" id="create-new-kit" onSubmit={handleSubmit}>
            <fieldset className="new_kit visible" ref={ref}>
                <div className="fat-input">
                    <input
                        autoComplete="off"
                        name="new-kit-name"
                        type="text"
                        placeholder="New Kit Name"
                        value={name}
                        onChange={onNameChange}
                        ref={nameInputRef}
                        data-test-id="kit-name-input"
                    />
                    <label
                        id="new-kit-name"
                        htmlFor="new-kit-name"
                        className="ui_kit icon-label"
                    />

                    <input
                        id="new-kit-is_public"
                        name="new-kit-is_public"
                        type="checkbox"
                        checked={is_public}
                        onChange={onIsPublicChange}
                        data-test-id="kit-public-input"
                    />
                    <label htmlFor="new-kit-is_public" className="icon-label">
                        <i className="ui_eye" title="Publicly viewable" />
                        <i
                            className="ui_eye-off"
                            title="Only viewable by you"
                        />
                    </label>
                    <KitErrors errors={fieldErrors} />
                </div>
                {ownerSelect}

                <div className="fat-input">
                    <textarea
                        id="new-kit-description"
                        name="new-kit-description"
                        placeholder="Description"
                        value={description}
                        onChange={onDescriptionChange}
                        data-test-id="kit-description-input"
                    />
                    <label
                        htmlFor="kit-description"
                        className="ui_description icon-label"
                    />
                </div>

                <button
                    data-test-id="kit-create-button"
                    className="ui_plus-circle-filled slide-in-icon"
                    type="submit"
                    onClick={handleSubmit}
                >
                    <span>Create kit</span>
                </button>
            </fieldset>
        </form>
    );
};

const mapStateToProps = state => {
    let { kits } = state;
    let { newKit, kitCreators, fieldErrors } = kits;
    return {
        kit: newKit,
        kitCreators,
        fieldErrors
    };
};

export const KitForm = connect(mapStateToProps, {
    kitsInputChange: actions.kitsInputChange
})(UnwrappedKitForm);
